module.exports = __webpack_public_path__ + "img/footer-facebook-icon.3305429c.svg";